import { Link } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

export const CARD =
  "bg-white/65 backdrop-blur-md rounded-[24px] border border-white/60 shadow-[0_2px_18px_rgba(10,25,47,0.08)]";

export function Row({ to, onClick, icon: Icon, label, hint, danger = false, testid }) {
  const cls = "w-full flex items-center gap-4 px-5 py-4 transition-colors active:bg-[#F0F0F0]";
  const labelColor = danger ? "text-[#B91C1C]" : "text-[#0A192F]";
  const iconBg = danger ? "bg-[#B91C1C]/10" : "bg-[#D4AF37]/14";
  const iconColor = danger ? "#B91C1C" : "#B8860B";
  const content = (
    <>
      <div className={`w-11 h-11 rounded-2xl ${iconBg} flex items-center justify-center shrink-0`}>
        <Icon size={22} weight="duotone" color={iconColor} />
      </div>
      <div className="flex-1 text-start min-w-0">
        <div className={`text-[17px] font-tajawal font-bold leading-tight ${labelColor}`}>{label}</div>
        {hint && <div className="text-[13.5px] font-tajawal text-[#5A6470] mt-1 leading-snug">{hint}</div>}
      </div>
      {!danger && <CaretLeft size={18} weight="bold" className="text-[#8A8A8A]" />}
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls}>{content}</Link>;
  return <button onClick={onClick} data-testid={testid} className={cls}>{content}</button>;
}

export function SectionTitle({ children }) {
  return (
    <h3 className="text-[14px] font-tajawal font-bold tracking-[0.18em] text-[#0A192F] uppercase mt-7 mb-3 px-2">
      {children}
    </h3>
  );
}

export function Group({ children }) {
  return (
    <div className={`${CARD} overflow-hidden`}>
      <div className="divide-y divide-[#EAEAEA]">{children}</div>
    </div>
  );
}

// Parses common date shapes (DD/MM/YYYY, YYYY-MM-DD) and returns a
// { level: "expired" | "warn", days, raw } marker when the bar card is
// expired or within 30 days of expiry — otherwise null.
export function computeExpiryStatus(barValidityUntil) {
  const raw = (barValidityUntil || "").trim();
  if (!raw) return null;
  const m = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/) || raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!m) return null;
  const [, a, b, c] = m;
  const y = Number(c.length === 4 ? c : a);
  const mo = Number(c.length === 4 ? b : b);
  const d = Number(c.length === 4 ? a : c);
  const dt = new Date(Date.UTC(y, mo - 1, d));
  const now = new Date();
  now.setUTCHours(0, 0, 0, 0);
  const diffDays = Math.floor((dt - now) / 86400000);
  if (diffDays < 0) return { level: "expired", days: diffDays, raw };
  if (diffDays <= 30) return { level: "warn", days: diffDays, raw };
  return null;
}
